import { Order } from "../interfaces/order.interface";

const STORAGE_KEY = "hk_microlaunch_orders";

export const getOrders = (): Order[] => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? (JSON.parse(raw) as Order[]) : [];
  } catch {
    return [];
  }
};

export const getOrdersForUser = (userId: string): Order[] =>
  getOrders().filter((order) => order.customer.userId === userId);

export const saveOrder = (order: Order): void => {
  const orders = getOrders();
  localStorage.setItem(STORAGE_KEY, JSON.stringify([order, ...orders]));
};

export const generateOrderId = (): string => {
  const date = new Date();
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  const suffix = Math.random().toString(36).slice(2, 6).toUpperCase();
  return `HKML-${y}${m}${d}-${suffix}`;
};
